<template>
    <div>
      <el-card>
        <h2>用户提现申请</h2>
        <el-form :inline="true">
          <el-form-item label="用户账号">
            <el-input v-model="searchQuery.account" placeholder="请输入用户账号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
          </el-form-item>
        </el-form>
  
        <el-table :data="withdrawList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column label="用户信息" width="auto">
            <template #default="{ row }">
              <div>账号：{{ row.user.account }}</div>
              <div>用户名：{{ row.user.username }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="提现金额" />
          <el-table-column prop="type" label="提现类型" >
            <template #default="{ row }" >
              <div>类型：{{ {'bank':'银行卡','USDT':'USDT'}[row.withdrawalMethod?row.withdrawalMethod.type:'bank'] }}</div>
              <div>姓名：{{ row.withdrawalMethod?row.withdrawalMethod.name:'' }}</div>
              <div>银行：{{ row.withdrawalMethod?row.withdrawalMethod.bank_name:'' }}</div>
              <div>卡号：{{ row.withdrawalMethod?row.withdrawalMethod.account:'' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注">
            <template #default="{ row }">
              <el-input
                v-model="row.remark"
                placeholder="请输入备注"
              />
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template #default="{ row }">
              <el-tag :type="row.status === 1 ? 'success' : row.status === 2 ? 'danger' : 'warning'">
                {{ row.status === 1 ? '已通过' : row.status === 2 ? '已拒绝' : '待处理' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="申请时间" />
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button v-if="row.status === 0" type="success" size="small" @click="handleWithdraw(row, 1)">通过</el-button>
              <el-button v-if="row.status === 0" type="danger" size="small" @click="handleWithdraw(row, 2)">拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="total"
          @current-change="handlePageChange"
        />
      </el-card>
    </div>
  </template>
  
  <script>
  import { getUserWithdraw, handleWithdraw } from '@/api/money';
  
  export default {
    data() {
      return {
        searchQuery: {
          account: ''
        },
        withdrawList: [],
        pagination: {
          page: 1,
          limit: 20
        },
        total: 0
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const params = {
          ...this.searchQuery,
          page: this.pagination.page,
          limit: this.pagination.limit
        };
        const { data } = await getUserWithdraw(params);
        this.withdrawList = data.items.map(item => ({
          ...item,
          user: item.user || { account: '', username: '' }
        }));
        this.total = data.total;
      },
      handleSearch() {
        this.pagination.page = 1;
        this.fetchData();
      },
      handlePageChange(page) {
        this.pagination.page = page;
        this.fetchData();
      },
      async handleWithdraw(row, status) {
        try {
          await handleWithdraw(row.id, status, row.remark);
          this.$message.success(status === 1 ? '已通过提现申请' : '已拒绝提现申请');
          row.status = status;
        } catch (error) {
          this.$message.error('处理失败');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .el-card {
    margin: 20px;
  }
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
  </style>